<template>
  <div v-if="this.isdraw==='0'">
    <img class="max-height-img" :src="getImgView()" />    
  </div>
  <div v-else>
    <canvas ref="myCanvas" height="580" width="336" style="touch-action: none;" class="myCanvas"></canvas>
    <span style="display: block;">
      <a-button  v-if="issave" @click="clearCanvas">清除</a-button>
      <a-button type="primary" v-if="issave" @click="saveCanvas" :loading="isLoading" style="margin-left:10px;">保存</a-button>
    </span>
  </div>
</template>

<script>
  import Vue from 'vue'
  import { ref, onMounted } from 'vue'
  import { ACCESS_TOKEN } from "@/store/mutation-types"
  import { getFileAccessHttpUrl,postAction } from '@/api/manage'
  
  export default {
    name: 'JImageDraw',
    data(){
      return {
        // uploadAction:window._CONFIG['domianURL']+"/sys/common/upload",
        isLoading:false,
        // picUrl:false,
        // headers:{},
        // fileList: [],
        // previewImage:"",
        // previewVisible: false,
        isDrawing: false,
        lastX: 0,
        lastY: 0,
        ctx: null,
      }
    },
    props:{
      /*是否需要用户画图（0：不需要（默认值），1: 需要）*/
      isdraw:{
        type:String,
        required:false,
        default:"0"
      },
      drawImg:{
        type:String,
        required:false,
        default:''
      },
      imgUrl:{
        type:String,
        required:true
      },
      issave:{
        type:Boolean,
        required: false,
        default:false
      },
      /*这个属性用于控制文件上传的业务路径*/
      bizPath:{
        type:String,
        required:false,
        default:"temp"
      },   
    },    
    created(){
      // const token = Vue.ls.get(ACCESS_TOKEN);
      // this.headers = {"X-Access-Token":token}
      // console.log("this.isdraw:"+ this.isdraw)
    },
    methods:{      
      getImgView(imgUrl){
        if(!imgUrl){
          imgUrl = this.imgUrl
        }
        console.log("getImgView:" + imgUrl)
        return getFileAccessHttpUrl(imgUrl)        
      },
      loadImage(imgUrl, isclear) {
        const img = new Image();
        var imgurl = this.getImgView(imgUrl)
        // console.log("imgurl:"+imgurl)
        img.crossOrigin = 'Anonymous'; // 设置 crossOrigin 属性
        img.src = imgurl
        img.onload = () => {
          let h = (this.drawImg && this.drawImg!=null && this.drawImg!='undefined' && !isclear) ?this.$refs.myCanvas.height:this.$refs.myCanvas.height/2;
          this.ctx.drawImage(img, 0, 0, this.$refs.myCanvas.width, h);
        };
      },
      start(e) {
        this.isDrawing = true;
        e.preventDefault();
        [this.lastX, this.lastY] = this.getTouchPosition(e);
      },
      draw(e) {
        if (!this.isDrawing) return;
        e.preventDefault();
        const [x, y] = this.getTouchPosition(e);
        this.ctx.beginPath();
        this.ctx.moveTo(this.lastX, this.lastY);
        this.ctx.lineTo(x, y);
        // console.log("this.lastX, this.lastY"+this.lastX+" , "+ this.lastY)
        this.ctx.stroke();
        [this.lastX, this.lastY] = [x, y];
      },
      stop() {
        this.isDrawing = false;
        this.ctx.beginPath();
      },
      getTouchPosition(e) {
        const touch = e.touches[0];
        const rect = this.$refs.myCanvas.getBoundingClientRect();
        // console.log("touch.clientX:"+touch.clientX)
        // console.log("touch.clientY:"+touch.clientY)
        // console.log("myCanvas.offsetLeft:"+this.$refs.myCanvas.offsetLeft)
        // console.log("myCanvas.offsetTop:"+this.$refs.myCanvas.offsetTop)
        
        return [touch.clientX-rect.left, touch.clientY-rect.top];
      },
      setupCanvas() {
        //console.log("this.$refs.myCanvas："+ this.$refs.myCanvas);
        this.ctx = this.$refs.myCanvas.getContext('2d');
        this.ctx.strokeStyle = 'red';
        this.ctx.lineJoin = this.ctx.lineCap = 'round';
        this.ctx.lineWidth = 1;
        this.$refs.myCanvas.addEventListener('touchstart', this.start, false);
        this.$refs.myCanvas.addEventListener('touchmove', this.draw, false);
        this.$refs.myCanvas.addEventListener('touchend', this.stop, false);
        let imgUrl = (this.drawImg!=null && this.drawImg!='undefined')?this.drawImg:this.imgUrl;
        console.log("private imgUrl:"+ imgUrl)
        this.loadImage(imgUrl);
      },
      clearCanvas(){
        this.ctx.clearRect(0, 0, this.$refs.myCanvas.width, this.$refs.myCanvas.height);
        this.loadImage(this.imgUrl,true);
      },
      saveCanvas(){
        this.isLoading = true
        this.$refs.myCanvas.toBlob(async blob => {
        if (blob) {
          const formData = new FormData();
          formData.append('file', blob, `${Date.now()}.png`);
          formData.append('biz', `${this.bizPath}/${new Date().getTime()}`)
          const res = await postAction('/sys/common/upload', formData);
          if (res.success) {            
            this.$emit('change', res.message);
            this.$message.info("保存成功")
          }else{
            this.$message.error("保存失败")
          }
        }
        this.isLoading = false
      })      
      },
      setCanvasSize() {
        return;
        const canvas = this.$refs.myCanvas;
        const parent = canvas.parentElement;
        if (parent) {        
          canvas.width = parent.offsetWidth;
          console.log("canvas.offsetWidth:"+parent.offsetWidth)
        }else{
          canvas.width = '600';
        }
      },
    },
    mounted() {
      if(this.isdraw==='1'){
        this.$nextTick(() => {
          // 调用初始化 canvas 尺寸的方法
          this.setCanvasSize();          
          // 监听窗口大小变化，调整 canvas 尺寸
          window.addEventListener('resize', this.setCanvasSize);
          this.setupCanvas();
        });
      }      
    },
    beforeDestroy() {
      // 清理事件监听器
      window.removeEventListener('resize', this.setCanvasSize);
    },
  }
</script>

<style scoped lang="less">

.max-height-img {
  max-height: 580px; /* 设置最大高度 */
  max-width: 336px; /* 保持宽高比 */
}
.myCanvas {
  border: 1px solid rgba(202, 192, 192, 0.788); /* 半透明黑色边框，宽度1px */
}
</style>